/**
 * Keep in mind that this has to be in sync with
 * olive/library/Olive/View/Catalog/NoResults/Suggestions.php
 */

import { getSuggestionFor } from './suggestion_factory';
import { sortSuggestions } from './suggestions_sorter';
import { Filters } from '../../_flux/constants/filter/filters';

function createSuggestions(activeFilters, currencyIsoCode) {
    const suggestions = Object.keys(activeFilters).map((key) => getSuggestionFor(activeFilters[key], key, currencyIsoCode));
    const filteredSuggestions = suggestions.filter(filterSuggestions);
    return sortSuggestions(filteredSuggestions, currencyIsoCode);
}

function filterSuggestions(suggestion) {
    return !(
        suggestionIsDefaultPrice(suggestion) ||
        suggestion.facetName === 'region' ||
        suggestion.facetName === Filters.POSTCODE ||
        suggestion.facetName === Filters.WIDTH ||
        suggestion.facetName === Filters.HEIGHT ||
        suggestion.facetName === Filters.DIAMETER
    );
}

function suggestionIsDefaultPrice(suggestion) {
    return parseInt(suggestion.filterValue) === 0;
}

export { createSuggestions };
